import LinearProgress from '@material-ui/core/LinearProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { FC } from 'react';

const useStyles = makeStyles(
  () => ({
    progress: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
    },
  }),
  { name: 'Checking' }
);

const GcpProgressBar: FC = () => {
  const classes = useStyles();

  return (
    <LinearProgress classes={{ root: classes.progress }} color="primary" />
  );
};

export default GcpProgressBar;
